/**
 * Fade entre páginas internas (overlay). Sin View Transitions API (evita doble animación con el overlay).
 */
(function () {
  var STORAGE_KEY = '1925_pt';
  var DURATION_MS = 400;
  var root = document.documentElement;
  var isLeaving = false;

  if (!root.classList.contains('site-1925')) return;
  if (root.classList.contains('shopify-design-mode')) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ensureOverlay() {
    var overlay = document.getElementById('page-transition-1925');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'page-transition-1925';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function setEnterPending() {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'out');
    } catch (e) {
      /* ignore */
    }
  }

  function clearEnterPending() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function shouldAnimateEnter() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'out';
    } catch (e) {
      return false;
    }
  }

  function fadeIn() {
    if (reducedMotion) {
      clearEnterPending();
      return;
    }

    ensureOverlay();
    if (!root.classList.contains('page-transition-1925--entering')) {
      root.classList.add('page-transition-1925--entering');
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.remove('page-transition-1925--entering');
        clearEnterPending();
      });
    });

    window.setTimeout(function () {
      var overlay = document.getElementById('page-transition-1925');
      if (overlay && overlay.parentNode) overlay.remove();
      var critical = document.getElementById('page-transition-1925-critical');
      if (critical && critical.parentNode) critical.remove();
    }, DURATION_MS + 80);
  }

  function fadeOutThenNavigate(url) {
    if (reducedMotion) {
      window.location.href = url;
      return;
    }

    if (isLeaving) return;
    isLeaving = true;

    setEnterPending();
    ensureOverlay();
    root.classList.add('page-transition-1925--leaving');

    window.setTimeout(function () {
      window.location.href = url;
    }, DURATION_MS);
  }

  function isModifiedClick(event) {
    return (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    );
  }

  function isSkippableLink(link) {
    if (!link || link.tagName !== 'A') return true;
    if (link.hasAttribute('data-no-page-transition')) return true;
    if (link.hasAttribute('data-intro-skip')) return true;
    if (link.target === '_blank' || link.hasAttribute('download')) return true;
    if (link.getAttribute('role') === 'button') return true;
    if (link.closest('[data-no-page-transition]')) return true;

    var href = link.getAttribute('href');
    if (!href || href === '#') return true;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) {
      return true;
    }

    return false;
  }

  function resolveUrl(href) {
    try {
      return new URL(href, window.location.href);
    } catch (e) {
      return null;
    }
  }

  function isInternalNavigation(link) {
    var next = resolveUrl(link.getAttribute('href'));
    if (!next) return false;
    if (next.origin !== window.location.origin) return false;

    var current = new URL(window.location.href);

    if (next.pathname === current.pathname && next.search === current.search) {
      return false;
    }

    if (next.hash) {
      return false;
    }

    if (next.pathname.indexOf('/checkout') === 0) return false;
    if (next.pathname.indexOf('/account') === 0 && link.getAttribute('href').indexOf('logout') !== -1) {
      return false;
    }

    return true;
  }

  function onLinkClick(event) {
    if (reducedMotion) return;
    if (isLeaving || root.classList.contains('page-transition-1925--leaving')) return;

    var link = event.target.closest('a');
    if (!link || isSkippableLink(link) || !isInternalNavigation(link)) return;
    if (isModifiedClick(event)) return;

    var next = resolveUrl(link.getAttribute('href'));
    if (!next) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    fadeOutThenNavigate(next.href);
  }

  function onPageShow(event) {
    isLeaving = false;
    root.classList.remove('page-transition-1925--leaving');
    if (event.persisted) {
      fadeIn();
    }
  }

  function init() {
    if (shouldAnimateEnter()) {
      fadeIn();
    }

    document.addEventListener('click', onLinkClick, true);
    window.addEventListener('pageshow', onPageShow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
